<template>
    <div
        v-if="loading"
        class="selection-list selection-list-container is-flex is-justify-content-center is-align-items-center"
        :style="{ height: boxHeight, maxHeight: boxHeight }"
        tabindex="0"
    >
        <LoadingSpinner2 />
    </div>

    <div
        v-else-if="categories.length === 0 && showEmptyState"
        class="selection-list selection-list-container has-text-centered is-flex is-justify-content-center is-align-items-center"
        :style="{ height: boxHeight, maxHeight: boxHeight }"
        tabindex="0"
    >
        <p class="has-text-grey">{{ emptyStateMessage }}</p>
    </div>

    <SelectionList v-else :options="categories" :readonly="true" :height="boxHeight">
        <template #option="{ option }">
            {{ formatCategory(option) }}
        </template>
    </SelectionList>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import LoadingSpinner2 from "../Common/LoadingSpinner2.vue";
    import SelectionList from "../Common/SelectionList.vue";
    import { translate } from "../Common/translations";

    type CategoryItem = string | { formattedName: string; path?: string };

    const props = withDefaults(
        defineProps<{
            categories: CategoryItem[];
            loading: boolean;
            showEmptyState?: boolean;
            emptyStateMessage?: string;
            flexHeight?: boolean;
        }>(),
        {
            showEmptyState: false,
            emptyStateMessage: () => translate("page.category_manager.no_categories_to_display"),
            flexHeight: false,
        },
    );

    const boxHeight = computed(() => (props.flexHeight ? "100%" : "300px"));

    function formatCategory(category: CategoryItem): string {
        return typeof category === "string" ? category : category.formattedName;
    }
</script>
